<template functional>
  <div v-show="props.isPageLoading" class="loading-spinner">
    <component
      :is="injections.components.BarLoader"
      :width="100"
      :height="6"
      color="#ef7d22"
      class="loading-spinner__spinner"
    >
    </component>
  </div>
</template>

<script>
import { BarLoader } from '@saeris/vue-spinners'

export default {
  name: 'LoadingSpinner',
  inject: {
    components: {
      type: Object,
      default() {
        return {
          BarLoader,
        }
      },
    },
  },
  props: {
    isPageLoading: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.loading-spinner {
  background-color: var(--dark-gray);
  text-align: center;
  z-index: 200;
  height: 100vh;
  margin: 35% 0 0 0;
  @include mobile {
    margin: 20% 0 0 0;
  }

  &__spinner {
    margin: 0 auto;
    color: var(--orange);
  }
}
</style>
